<style lang="scss" scoped>
@import '../css/sub.scss';
</style>
<template>
  <div class="urban-asset question-page">
    <urban-header></urban-header>
    <div class="urban-sub">
      <div class="board-contents">
        <h2 class="title">자주하는 질문</h2>
        <div class="question-template">
          <ul class="question-list">
            <li class="list-item" v-for="(item, index) in questionItems" :key="index">
              <button type="button" class="item-btn" @click="item.hidden = !item.hidden">
                <span class="mark">Q.</span>
                <span class="tit">{{item.qstTitle}}</span>
                <i class="icon plus-icon"></i>
              </button>
              <div class="desc-area" v-if="item.hidden == false">
                <div class="contents" v-html ="item.qstDesc"></div>
                <!--<p class="default-txt">
                  {{item.qstDesc}}
                </p> -->
              </div>
            </li>
          </ul>
          <div class="call-area">
            <a href="#" class="link">유선문의: 02-6196-7800</a>
          </div>
        </div>
      </div>
    </div>
    <urban-footer></urban-footer>
  </div>
</template>
<script>
import UrbanHeader from '@/components/UrbanHeader'
import UrbanFooter from '@/components/UrbanFooter'

import { mapGetters } from 'vuex'

export default {
  name: 'ViewQuestion',
  components: {
    'urban-header': UrbanHeader,
    'urban-footer': UrbanFooter
  },
  mounted () {
    this.initQuestions()
  },
  data () {
    return {
    }
  },
  watch: {
    questionItems () {
      for (var i = 0; i < this.questionItems.length; i++) {
        this.$set(this.questionItems[i], 'hidden', true)
      }
    }
  },
  methods: {
    initQuestions: function () {
      this.$store.dispatch('apiQuestions')
    }
  },
  computed: {
    ...mapGetters({
      questionItems: 'getQuestions'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ViewQuestion.vue